import App from '@/models/App'
import Document from '@/models/Document'

export default class Folder extends App {
    static get entity() {
        return 'Folders'
    }
    static fields() {
        return {
            id: this.attr(''),
            userId: this.attr(''),
            userName: this.attr(''),
            parentId: this.attr(''),
            name: this.attr(''),
            origin: this.attr(''),
            files: this.attr(''),
            size: this.attr(''),
            createdAt: this.attr(''),
            updatedAt: this.attr(''),
            breadcrumb: this.attr(''),
            children: this.attr(''),
            // documents: this.hasMany(Document, "folder_id"),

            isShowSidebar: this.attr(false),
            shareFolderId: this.attr(''),
            shareDocumentId: this.attr(''),
            shareFolderName: this.attr(''),
            shareDocumentName: this.attr(''),
        }
    }
    static all() {
        return this.query().withAllRecursive().get()
    }
    static getRootFolder(folderName = 'マイドライブ') {
        return this.query()
            .where('name', folderName)
            .where('parentId', null)
            .first()
    }
    static getTotalSize(userId) {
        const folders = this.query().where('userId', userId).get()
        return folders.reduce((sum, i) => sum + i.size, 0)
    }
    static apiConfig = {
        actions: {
            fetch() {
                return this.get(`/folders`, {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.overallURL(),
                })
            },
            fetchByShare() {
                return this.get(`/folders/share`, {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.overallURL(),
                })
            },
            search(params) {
                return this.post(`/folders/search`, App.post(params), {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.overallURL(),
                })
            },
            create(params) {
                return this.post(`/folders`, App.post(params), {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.overallURL(),
                })
            },
            update(folderId, params) {
                return this.patch(`folders/${folderId}`, App.patch(params), {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.overallURL(),
                })
            },
            destroy(folderId) {
                return this.delete(`folders/${folderId}`, {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.overallURL(),
                })
            },
        },
    }
}
